import { IOrganization } from 'src/app/common/modules/dialog-pop-ups/components/forget-password-dialog/forget-password-dialog.component';
import { UserRegDetails } from 'src/app/models/user';

export interface IAuthenticationState {
  flows: {
    isLogin: boolean;
    isForgotPassword: boolean;
    isUserRegistration: boolean;
    isSendingOTP: boolean;
  };
  login: {
    loginType: number;
    accountID: string;
    accountPIN: string;
    username: string;
    userEmail: string;
    userMobile: string;
    userPassword: string;
    errorMessage: string;
  };
  newUser: {
    orgName: string;
    orgType: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    gender: string;
    dob: string;
  };
  status: {
    isRegistrationSuccess: boolean;
    isGuestLoggedIn: boolean;
    isDashboardInitiated: boolean;
    isLoginFailed: boolean;
    hasAccessToken: boolean;
    isRedirectToLogin: boolean;
    isFetchingAPIRequest: boolean;
    isSendingOtpLogin: boolean;
    isMobileExists: boolean;
    isOtpSent: boolean;
    isOrganizationCreated: boolean;
    isError: boolean;
    isUserFound: boolean;
  };
  organizations: IOrganization[];
  userFound: UserRegDetails;
  userKey: string;
}

export const initIAuthenticationState: IAuthenticationState = {
  flows: {
    isLogin: false,
    isForgotPassword: false,
    isUserRegistration: false,
    isSendingOTP: false,
  },
  userKey: null,
  login: {
    loginType: null,
    accountID: null,
    accountPIN: null,
    username: null,
    userEmail: null,
    userMobile: null,
    userPassword: null,
    errorMessage: null,
  },
  newUser: {
    orgName: null,
    orgType: null,
    email: null,
    phone: null,
    firstName: null,
    lastName: null,
    gender: null,
    dob: null,
  },
  status: {
    isRegistrationSuccess: false,
    isLoginFailed: false,
    isGuestLoggedIn: false,
    isFetchingAPIRequest: false,
    isSendingOtpLogin: false,
    isDashboardInitiated: false,
    hasAccessToken: false,
    isRedirectToLogin: false,
    isOtpSent: false,
    isOrganizationCreated: false,
    isError: false,
    isUserFound: false,
    isMobileExists: false,
  },
  organizations: [],
  userFound: null,
};
